import React from 'react'

import { Text } from '~/components/text/Text'
import { cn } from '~/styled'

type TStyledTreeTextProps = React.ComponentProps<typeof Text>

export const TreeText = ({
  className,
  ...rest
}: TStyledTreeTextProps): React.JSX.Element => (
  <Text
    as="span"
    {...rest}
    className={cn(
      'py-0.5',
      'whitespace-nowrap',
      'overflow-x-hidden',
      'text-ellipsis',
      className
    )}
    size="md"
  />
)
